import React from 'react'
import BaseComponent from '../../../../BaseComponent';
import LocUtils from '../../../../../util/localization/LocUtils';
import './Rail.css'
import Farm2Feeds from '../lib/Farm2Feeds';


class RailHeader extends BaseComponent {
    // Recieves:
    // => options
    // => onOptionChangeHandler
    // => state
    constructor(props) {
        super(props);

        this.getMenu = this.getMenu.bind(this);
        this.isSelected = this.isSelected.bind(this);
    }

    isSelected(stuff) {
        return (stuff && stuff.name === this.props.state.currentSelection.name) ? true : false;
    }

    openFrineds(evt) {
        var tablinks = document.getElementsByClassName("tablinks");
        for (var i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        evt.currentTarget.className += " active";
    }

    openEverybody(evt) {
        var tablinks = document.getElementsByClassName("tablinks");
        for (var i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        evt.currentTarget.className += " active";

        //poulate data
    }

    getMenu() {
        var totalKeys = Object.keys(this.props.options).length;
        if (totalKeys === 0) {
            super.fatal("Unknown number of args for rails menu. This is bad :( ");
            return <div></div>;
        }
        var op = <div></div>;
        if (totalKeys === 1) {
            // op = <div className="rail-menu-single nominal-padding">
            //     {LocUtils.T(this.props.options[Object.keys(this.props.options)[0]].loc)}
            // </div>
        } else {
            op = <div className="rail-menu-multi input-group mb-3 nominal-padding">
                <select value={this.props.state.currentSelection.name} className="custom-select" id="menu-options-select" onChange={this.props.onChangeRailOption}>
                    {Object.keys(this.props.options).map((key, index) => (
                        <option key={index} value={this.props.options[key].name} selected={this.isSelected(this.props.options[key])}>
                            {LocUtils.T(this.props.options[key].loc)}
                        </option>
                    ))}
                </select>
            </div>
        }

        return op;
    }

    render() {
        return (
            <div>
                {/* We will later use this space to configure any other options */}
                <div className="rail-header rounded-corners-top">
                    <div className="nominal-padding">{LocUtils.T("pages.games.farm2.rail.rail_header")}</div>
                </div>
            </div>
        )
    }
}


class RailFrame extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
        this._cache = {};
    }


    render() {
        return (
            // Load whatever component has been selected
            <this.props.selected.component {...this.props} />
        )
    }
}

/**
 * The main Rail orchestrator
 */
class Rail extends BaseComponent {

    constructor(props) {
        super(props);
        this.options = {
            feeds: {
                name: "feeds",
                loc: "pages.games.farm2.rail.menu_opts.feeds",
                component: Farm2Feeds
            }
        }
        this.state = {
            currentSelection: this.options.feeds,
            rightRailOn: true
        }
        this.onChangeRailOption = this.onChangeRailOption.bind(this);
    }

    /** 
     * Handler to address things when the 
     * rail options are changed 
     */
    onChangeRailOption(evt) {
        if (evt) {
            evt.preventDefault();
            var newSelection = evt.target.value;
            this.setState({
                currentSelection: this.options[newSelection]
            })
        }
    }

    render() {
        return (
            //onClick={this.onRightRailToggle}
            <div onClick={this.props.onRightRailToggle} hidden={!this.state.rightRailOn} id="farm2-rail" className="col-2-5 feed-column">
                <div id="rail-header-container" className="row no-gutters" >
                    <div className="col rail-containers">
                        <RailHeader
                            options={this.options}
                            onChangeRailOption={this.onChangeRailOption}
                            state={this.state}
                        />
                    </div>
                </div>
                <div className="row no-gutters" >
                    <div className="col rail-containers">
                        <RailFrame
                            selected={this.state.currentSelection}
                            {...this.props}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default Rail;